var errorKeys = {
    wrongHeaderFormat: 'wrong-header-format',
    wrongScheme: 'wrong-scheme',
    missingHeader: 'missing-auth-header'
};

module.exports = errorKeys;